import useCustomer from '@lib/hooks/useCustomer'
import useSubscriptionBoxContractDetails from '@lib/hooks/useSubscriptionBoxContractDetails'

import PasswordForm from '@components/profile/AccountInformation/PasswordForm'
import PersonalInformationForms from '@components/profile/AccountInformation/PersonalInformationForms'
import AccountLayout from '@components/profile/layout/AccountLayout'

export default function Information() {
	const { customer } = useCustomer()
	const { subscriptioBoxContractDetails } = useSubscriptionBoxContractDetails()

	return (
		// <div className="grid lg:grid-cols-1 lg:pl-14 pt-9 pb-32 col-span-2">
		// 	{/* This was added as temp code for the recharge migration and should be removed as of March 8th post migration. */}
		// 	<div className="p-8 bg-bbx-pearl-light text-bbx-spark content-center rounded-[8px] text-center mt-5 h-fit">
		// 		<svg className="fill-bbx-spark m-auto" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M768-120 517-371l57-57 251 251-57 57Zm-581 0-57-57 290-290-107-107-23 23-44-44v85l-24 24-122-122 24-24h86l-48-48 131-131q17-17 37-23t44-6q24 0 44 8.5t37 25.5L348-699l48 48-24 24 104 104 122-122q-8-13-12.5-30t-4.5-36q0-53 38.5-91.5T711-841q15 0 25.5 3t17.5 8l-85 85 75 75 85-85q5 8 8.5 19.5T841-709q0 53-38.5 91.5T711-579q-18 0-31-2.5t-24-7.5L187-120Z"/></svg>
		// 		<h3 className="mb-6 text-3xl text-center title" style={{ display: 'flex',justifyContent: 'center'}}>
		// 			Under Construction
		// 		</h3>
		// 		<p>We apologize for the inconvenience, but account details may not be changed at this time due to scheduled maintenance. They will be available May 13th. Please contact customer service at <a className="font-bold" href="mailto:info@birchbox.com">info@birchbox.com</a> if you need further assistance.</p>
		// 	</div>
		// </div>
		<div className="grid lg:grid-cols-2 lg:pl-14 pt-9 pb-32 gap-x-12 xl:gap-x-[4.5rem] max-lg:gap-y-8 col-span-2">
			{customer && (
				<>
					{/* Update Personal Information and Delivery Address form */}
					<PersonalInformationForms
						customer={customer}
						subscriptionAddress={subscriptioBoxContractDetails?.shippingAddress}
					/>

					{/* Update password form */}
					<PasswordForm />
				</>
			)}
		</div>
		// <div className="grid lg:grid-cols-1 lg:pl-14 pt-9 pb-32 col-span-2">
		// 	{/* This was added as temp code for the recharge migration and should be removed as of March 8th post migration. */}
		// 	<div className="p-8 bg-bbx-pearl-light text-bbx-spark content-center rounded-[8px] text-center mt-5 h-fit">
		// 		<svg className="fill-bbx-spark m-auto" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path d="M768-120 517-371l57-57 251 251-57 57Zm-581 0-57-57 290-290-107-107-23 23-44-44v85l-24 24-122-122 24-24h86l-48-48 131-131q17-17 37-23t44-6q24 0 44 8.5t37 25.5L348-699l48 48-24 24 104 104 122-122q-8-13-12.5-30t-4.5-36q0-53 38.5-91.5T711-841q15 0 25.5 3t17.5 8l-85 85 75 75 85-85q5 8 8.5 19.5T841-709q0 53-38.5 91.5T711-579q-18 0-31-2.5t-24-7.5L187-120Z"/></svg>
		// 		<h3 className="mb-6 text-3xl text-center title" style={{ display: 'flex',justifyContent: 'center'}}>
		// 			Under Construction
		// 		</h3>
		// 		<p>We apologize for the inconvenience, but account details may not be changed at this time due to scheduled maintenance. They will be available May 9th. Please contact customer service at <a className="font-bold" href="mailto:info@birchbox.com">info@birchbox.com</a> if you need further assistance.</p>
		// 	</div>
		// </div>
	)
}

Information.Layout = AccountLayout
